import React from "react";
import { Routes, Route } from "react-router-dom";
import { jobTypes, jobNamesMap } from "../config/jobTypes"; // Assuming your job types and mapping are defined in a constants file
import GarmentAttributeTool from "../screens/tools/garmentAttribute/GarmentAttributeTool";
import ImageAttributeTool from "../screens/tools/imageAttribute/ImageAttributeTool";
import GarmentAttributeQaTool from "../screens/tools/garmentAttribute/GarmentAttributeQATool";
import AggregationLinkingTool from "../screens/tools/aggregation/AggregationLinkingTool";
import MultiGarmentAttributeTool from "../screens/tools/garmentAttribute/MultiGarmentAttributeTool";
import ImageAttributeQaTool from "../screens/tools/imageAttribute/ImageAttributeQATool";
import AggregationGroupingTool from "../screens/tools/aggregation/AggregationGroupingTool";
import WrappedAggregationTool from "../screens/tools/aggregation/AggregationTool";
import WrappedAggregationQATool from "../screens/tools/aggregation/AggregationQATool";
import WrappedRepresentativeSelectionTool from "../screens/tools/representativeSelection/RepresentativeSelectionTool";

const JobsRoutes = () => {
  // Function to determine which tool to render based on the job type
  const renderToolForJob = (jobType) => {
    switch (jobNamesMap[jobType]) {
      case jobTypes.IMAGE_TAGGING:
        return <ImageAttributeTool />;
      case jobTypes.IMAGE_TAGGING_QA:
        return <ImageAttributeQaTool />;
      // Add cases for other job types and tools as needed
      case jobTypes.TYPE:
        return <GarmentAttributeTool />;
      case jobTypes.TYPE_QA:
        return <GarmentAttributeQaTool />;
      case jobTypes.STYLE_QA:
        return <GarmentAttributeQaTool />;
      case jobTypes.STYLE_MAGNETS:
        return <MultiGarmentAttributeTool />;
      case jobTypes.STYLE:
        return <GarmentAttributeTool />;
      case jobTypes.AGGREGATION:
        return <WrappedAggregationTool />;
      case jobTypes.AGGREGATION_QA:
        return <WrappedAggregationQATool />;
      case jobTypes.REP_SELECTION:
        return <WrappedRepresentativeSelectionTool />;

      default:
        return null; // Render nothing if the job type is not recognized
    }
  };

  return (
    <Routes>
      {/* Map job types to corresponding routes */}
      {Object.keys(jobNamesMap).map((jobName) => (
        <Route
          key={jobName}
          path={`/${jobName}/:id`} // Assuming your job names map directly to route paths
          element={renderToolForJob(jobName)}
        />
      ))}
      <Route path="linking" element={<AggregationLinkingTool />} />
      <Route path="grouping" element={<AggregationGroupingTool />} />
    </Routes>
  );
};

export default JobsRoutes;
